<framework-assets-image
  [assetFile]="assetFile"
  [size]="size"
  (loaded)="loaded.emit(true)"
  (errored)="errored.emit(true)"
>
  <framework-asset-image-content>
    @if (details) {
    <div class="left" (click)="openLink()">
      <div class="icon-title">
        <mat-icon [ngClass]="$safeNavigationMigration(project?.status?.id)">category</mat-icon>
        <p class="title">{{ project?.name }}</p>
      </div>
      <p class="subtitle">
        {{ project.productType ? project.productType.name + ' •' : null }} {{ project.projectEndDate | date : 'MMM dd,
        yyyy' }}
      </p>
    </div>
    }

    <div class="click" (click)="openLink()"></div>

    @if (showMembers === true && project?.members) {
    <framework-clusted-profile-images [userList]="project.members"></framework-clusted-profile-images>
    }
  </framework-asset-image-content>
</framework-assets-image>
